interface OwnProps {
  onClick?: () => void;
  imageProps: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;
}
export const ClickableImage: React.FC<OwnProps> = (props) => {
  const { onClick, imageProps } = props;
  return (<img onClick={onClick} {...imageProps} style={{...imageProps?.style, cursor: 'pointer'}} alt="clickable" />)
}